import loadMap from "/canvas/extensions/loadMap.js";
import closeMap from "/canvas/extensions/closeMap.js";
import { getMousePosElement, getMousePosImage } from "/canvas/extensions/getMousePos.js";
import getImageUrl from "/canvas/extensions/getImageUrl.js";
import saveWorldFile from "/canvas/extensions/saveWorldFile.js";
import { getTileColor } from "/canvas/extensions/getTileInfo.js";
import blockSwap from "/canvas/extensions/blockSwap.js";
import blockReplace from "/canvas/extensions/blockReplace.js";
import zoom from "/canvas/extensions/zoom.js";

export default {
    loadMap,
    closeMap,
    getMousePosElement,
    getMousePosImage,
    getImageUrl,
    saveWorldFile,
    getTileColor,
    blockSwap,
    blockReplace,
    zoom
}